export type ProviderLoadState =
    | "error"
    | "loading"
    | "preview"
    | "not-found"
    | "ready";

export function getProviderLoadState(input: {
    breederIsError: boolean;
    hasBreederData: boolean;
    hasBreeder: boolean;
    listingsIsError: boolean;
    hasListingPage: boolean;
    hasHeadName: boolean;
}): ProviderLoadState {
    if (
        (input.breederIsError && !input.hasBreederData) ||
        (input.listingsIsError && !input.hasListingPage)
    ) {
        return "error";
    }
    if (!input.hasListingPage) return "loading";
    if (!input.hasBreeder) {
        if (input.hasHeadName) return "preview";
        if (!input.hasBreederData) return "loading";
        return "not-found";
    }
    return "ready";
}
